import React from 'react';
import SidebarHeader from '../layout/SidebarHeader';

import Apps from './Apps';
import Locate from './Locate';
import Search from './Search';
// import Visualize from './Visualize';

const SidebarAppLibrary = ({ onClose }) => (
  <>
    <SidebarHeader onClose={onClose} />
    <Search />
    <Apps />
    <Locate />
  </>
)

export default SidebarAppLibrary;